import { createContext, useContext } from 'react';

export type VerificationContextValues = {
  showVerificationModal: () => void;
  showSuccessModal: () => void;
  isVerified: boolean;
  ensureVerified: () => boolean;
  isEmailVerificationEnabled: boolean;
  isEmailVerified: boolean;
  isPhoneVerificationEnabled: boolean;
  isPhoneNumberVerified: boolean;
  refetch: () => void;
};

const defaultContextValues: VerificationContextValues = {
  showVerificationModal: () => {},
  showSuccessModal: () => {},
  isVerified: true,
  ensureVerified: () => true,
  isEmailVerificationEnabled: false,
  isEmailVerified: false,
  isPhoneVerificationEnabled: false,
  isPhoneNumberVerified: false,
  refetch: () => {}
};

export const VerificationContext =
  createContext<VerificationContextValues>(defaultContextValues);
export const useVerification = () => useContext(VerificationContext);
